module.exports = __webpack_public_path__ + "static/media/customer-chimay.png.82357d23.png";